import { Modal } from "react-bootstrap";

const PolicySectionModal = ({ modalHeading, modalContent, show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header className="sticky-top bg-white" closeButton>
        <Modal.Title className="h4">{modalHeading}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="mb-3">
        {modalContent && (
          <div
            dangerouslySetInnerHTML={{
              __html: modalContent
            }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};
export default PolicySectionModal;
